import axios from 'axios';
import * as React from 'react';
import {Container} from '../grid/container';
import {FormLib} from '../libs/form.lib';
import {FormValidators} from '../libs/form.validators';
import './style.scss';
import {ModalComponent} from "../libs/modal/modal.component";
import {Translation} from "../../lang";

const lineHeight: number = 20;
const planeSvg: string = '/assets/src/components/contact/plane.svg';
const facebookIcon: string = '/assets/src/components/contact/facebook.svg';
const linkedinIcon: string = '/assets/src/components/contact/linkedin.svg';

export class ContactComponent extends React.Component<any, any> {
    private textAreaRef: HTMLTextAreaElement;
    private tcModalRef: any;
    public form: FormLib = new FormLib({
        name: {
            value: '',
            validators: [
                FormValidators.REQUIRED(Translation.get('contact.form.validator.required'))
            ]
        },
        email: {
            value: '',
            validators: [
                FormValidators.REQUIRED(Translation.get('contact.form.validator.required')),
                FormValidators.EMAIL(Translation.get('contact.form.validator.email'))
            ]
        },
        phone: {
            value: '',
            validators: [
                FormValidators.REQUIRED(Translation.get('contact.form.validator.required'))
            ]
        },
        message: {
            value: '',
            validators: []
        },
        gdpr: {
            value: false,
            validators: [
                FormValidators.REQUIRED('')
            ]
        }
    });

    public state: any = {
        success: false,
        error: false,
        gpdrModal: false,
        eulaModal: false,
        rows: 1
    };

    componentDidMount() {
        this.form.setContext(this);
        document.querySelectorAll('.plain').forEach((element: Element) => element.classList.remove('UNINIT'));

        this.form.onChanges$.subscribe(() => {
            const oldRows = this.textAreaRef.rows;
            this.textAreaRef.rows = 1;
            const newRows = ~~(this.textAreaRef.scrollHeight / lineHeight);

            if (newRows === oldRows) {
                this.textAreaRef.rows = newRows;
            }

            this.setState({rows: newRows});

            if (this.textAreaRef.value !== '') {
                this.textAreaRef.classList.add('has-text');
            }
        });
    }

    async onFormSubmit(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.form.validateForm();

        if (this.form.isValid()) {

            try {
                await axios.post('/mailSend.php', this.form.values.toJS());
                this.setState({success: true});
            } catch (e) {
                this.setState({error: true});
            }
        }

    }

    render() {
        return <div>
            <ModalComponent isTC={true} ref={(ref: any) => { this.tcModalRef = ref; }}>
                <div>
                    <div className='container content-text'>

                        <h2>Az InteliArt Online Marketing <br/>ADATVÉDELMI ÉS ADATKEZELÉSI TÁJÉKOZTATÓJA</h2>
                        <ol>
                            <li>A Tájékoztató célja, hatálya
                                <br/><br/>
                                <ol>
                                    <li>A jelen Tájékoztató célja, hogy rögzítse az InteliArt Online Marketing Kft.
                                        (Székhely: 2440 Százhalombatta, Csalogány utca 19.
                                        Cégjegyzékszám: 13-09-205891; CÉG ADÓSZÁMA: 23160277-2-13
                                        Adatkezelő által „a <a href="https://www.inteliart.hu/" target="_blank">www.inteliart.hu</a>”
                                        Honlap
                                        üzemeltetése során alkalmazott adatvédelmi szabályokat.
                                    </li>
                                    <li>A jelen Tájékoztató a Felhasználók által megadott adatok kezelésének elveit
                                        tartalmazza.
                                    </li>
                                    <li>Figyelembe vett joszabályok: az Európai Parlament és a Tanács 2016/679
                                        Rendelete
                                        („Általános Adatvédelmi Rendelet” vagy „GDPR”), az információs
                                        önrendelkezési
                                        jogról és az információszabadságról szóló 2011. évi CXII. törvény
                                        („Infotv.”), a
                                        Polgári Törvénykönyvről szóló 2013. évi V. törvény („Ptk.”), továbbá a
                                        gazdasági
                                        reklámtevékenység alapvető feltételeiről és egyes korlátairól szóló 2008.
                                        évi
                                        XLVIII. törvény („Grtv.”).
                                    </li>
                                </ol>
                            </li>
                            <li>Értelmező rendelkezések:
                                <br/><br/>
                                <ol>
                                    <li>Adatkezelés : az alkalmazott eljárástól függetlenül a Személyes adatokon
                                        végzett
                                        bármely művelet vagy a műveletek összessége, így különösen a Személyes
                                        adatok
                                        gyűjtése, rögzítése, rendszerezése, tagolása, tárolása, átalakítása,
                                        megváltoztatása, felhasználása, lekérdezése, betekintése, felhasználása,
                                        közlése, továbbítása, terjesztése vagy egyéb módon hozzáférhetővé tétele,
                                        nyilvánosságra hozatala, összehangolása vagy összekapcsolása, korlátozása,
                                        törlése és megsemmisítése.
                                    </li>
                                    <li>Adatkezelő: aki az Adatkezelés céljait és eszközeit – önállóan vagy másokkal
                                        együtt –meghatározza. A jelen Tájékoztatóban hivatkozott Szolgáltatások
                                        esetében
                                        Adatkezelőnek minősül: InteliArt Online Marketing Kft. (Székhely: 2440 Százhalombatta, Csalogány utca 19.
                                        Cégjegyzékszám: 13-09-205891; CÉG ADÓSZÁMA: 23160277-2-13
                                        továbbiakban: „Adatkezelő”)
                                    </li>
                                    <li>Személyes adat: bármilyen adat vagy információ, amely alapján egy
                                        természetes
                                        személy Felhasználó – közvetett vagy közvetlen módon – azonosíthatóvá válik.
                                    </li>
                                    <li>Honlap: az Adatkezelő által üzemeltetett <a href="https://www.inteliart.hu/"
                                                                                   target="_blank">www.inteliart.hu</a> internetes
                                        oldal.
                                    </li>
                                    <li>Szolgáltatás(ok): az Adatkezelő által üzemeltetett valamint az Adatkezelő
                                        által
                                        biztosított szolgáltatások, amelyek elérhetők a Honlapon .
                                    </li>
                                    <li>Felhasználó: az a jogi-, illetve természetes személy (egyéni vállalkozó),
                                        aki a
                                        Szolgáltatásokra a Honlapon megadott módok valamelyike szerint az
                                        Adatkezelővel
                                        regisztrál/kapcsolatot létesít, és ennek keretében megadja az alábbi III.
                                        pontban felsorolt adatát.
                                    </li>
                                    <li>Külső szolgáltató: az Adatkezelő által, a Honlap üzemeltetéséhez vagy a
                                        Honlapon
                                        keresztül elérhető Szolgáltatások biztosításához kapcsolódóan – akár
                                        közvetlenül, akár közvetetten – igénybe vett harmadik fél szolgáltató
                                        partnerek,
                                        amelyek számára a szolgáltatásaik biztosítása érdekében Személyes adatok
                                        továbbításra kerülnek vagy kerülhetnek, illetve akik az Adatkezelő részére
                                        Személyes adatokat továbbíthatnak. Külső szolgáltatónak minősülnek továbbá
                                        azon
                                        szolgáltatók is, amelyek nem állnak az Adatkezelővel sem együttműködésben,
                                        azonban az által, hogy hozzáférnek a Szolgáltatások honlapjához, a
                                        Felhasználókról adatokat gyűjtenek, amelyek akár önállóan, akár más
                                        adatokkal
                                        összekapcsolva alkalmasak lehetnek a Felhasználó azonosítására.
                                    </li>
                                    <li>Tájékoztató : az Adatkezelő jelen adatkezelési tájékoztatója.</li>
                                    <li>Adatvédelmi incidens: a biztonság olyan sérülése, amely a továbbított,
                                        tárolt
                                        vagy más módon kezelt személyes adatok véletlen vagy jogellenes
                                        megsemmisítését,
                                        elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való
                                        jogosulatlan hozzáférést eredményezi;
                                    </li>
                                    <li>Érintett: bármely meghatározott, személyes adat alapján azonosított vagy-
                                        közvetlenül vagy közvetve-azonosítható természetes személy (az információs
                                        önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII.
                                        törvény
                                        3. § 1. pont).
                                    </li>
                                    <li>Érintett hozzájárulása: az Érintett akaratának önkéntes, konkrét és
                                        megfelelő
                                        tájékoztatáson alapuló és egyértelmű kinyilvánítása, amellyel az érintett
                                        nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján
                                        jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez.
                                    </li>
                                </ol>
                            </li>
                            <li>A kezelt adatok:
                                <br/><br/>
                                <ol>
                                    <li>Ha a Felhasználó a Honlap felületét látogatja, az Adatkezelő rendszere
                                        automatikusan rögzíti a Felhasználó IP címét.
                                    </li>
                                    <li>A Felhasználó döntése alapján az Adatkezelő a Honlapon keresztül elérhető
                                        szolgáltatások igénybevételéhez kapcsolódóan kezelheti az alábbi adatokat:
                                        név,
                                        székhely/telephely, e-mail cím, utolsó belépés IP címe, utolsó belépés
                                        időpontja, telefonszám(ok), üzlet elnevezés, kapcsolattartó adatai.
                                    </li>
                                    <li>Amennyiben a Felhasználó valamely Szolgáltatás részére e-mailt küld, úgy az
                                        Adatkezelő rögzíti a Felhasználó e-mail címét, és azt a szolgáltatás
                                        nyújtásához
                                        szükséges mértékben és időtartamban kezeli.
                                    </li>
                                    <li>Adatkezelő tartalom szerkesztési tevékenysége során kezeli mindazon
                                        természetes
                                        személyek megadott adatát, akik a tartalom előállításában közreműködtek,
                                        akár
                                        forrásként, akár oly módon, hogy a szerkesztett tartalomban meghivatkozásra
                                        kerülnek. Ebben az esetben az Adatkezelő által leggyakrabban kezelt
                                        személyes
                                        adatok lehetnek: az érintett neve, beosztása, munkahelye, ill. egyéb olyan
                                        adat,
                                        amely arra utal, hogy az érintett miként kapcsolódik a szerkesztett tartalom
                                        témájához.
                                    </li>
                                </ol>
                            </li>
                            <li>Az Adatkezelő által kezelt további adatok
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő a zavartalan kiszolgálás érdekében a Felhasználó számítógépén
                                        kis
                                        adatcsomagot (ún. „cookie”-t) helyeznek el. A cookie célja az adott oldal
                                        minél
                                        magasabb színvonalú működésének biztosítása, személyre szabott
                                        szolgáltatások
                                        biztosítása, a felhasználói élmény növelése. A cookie-t a Felhasználó képes
                                        törölni saját számítógépéről, illetve beállíthatja böngészőjét, hogy a
                                        cookie-k
                                        alkalmazását tiltsa. A cookie-k alkalmazásának tiltásával a Felhasználó
                                        tudomásul veszi, hogy cookie nélkül az adott oldal működése nem teljes
                                        értékű.
                                    </li>
                                    <li>A rendszerek működtetése során technikailag rögzítésre kerülő adatok: a
                                        Felhasználó bejelentkező számítógépének azon adatai, melyek a Szolgáltatás
                                        igénybe vétele során generálódnak, és amelyeket az Adatkezelő rendszere a
                                        technikai folyamatok automatikus eredményeként rögzít. Az automatikusan
                                        rögzítésre kerülő adatokat a rendszer a Felhasználó külön nyilatkozata vagy
                                        cselekménye nélkül a belépéskor, illetve kilépéskor automatikusan naplózza.
                                    </li>
                                </ol>
                            </li>
                            <li>Az Adatkezelés célja, jogalapja
                                <p>Az Adatkezelők által folytatott adatkezelések célja:</p>
                            </li>
                        </ol>
                        <ol>
                            <li>II. Értékesítés elősegítése;</li>
                            <li>i.online tartalomszolgáltatás;</li>
                            <li>iii.a Felhasználó azonosítása, a Felhasználóval való kapcsolattartás;</li>
                            <li>iv.a Felhasználói jogosultságok (a Felhasználó által igénybe vehető szolgáltatások)
                                azonosítása;
                            </li>
                            <li>v.a Felhasználó által igénybe vett szolgáltatások valamint a hirdetések
                                testreszabásának
                                elősegítése, a kényelmi funkciók igénybevétele;
                            </li>
                            <li>vi.egyedi felhasználói megkeresések kezelése, intézése</li>
                            <li>vii.statisztikák, elemzések készítése;</li>
                            <li>viii.közvetlen üzletszerzési illetve marketing célú megkeresés (pl. hírlevél, eDM,
                                stb.)
                            </li>
                            <li>ix.Felhasználó által generált tartalmak (pl. hozzászólás, fórum stb.) közzétételéhez
                                felület (tárhely) biztosítása;
                            </li>
                            <li>x.egyedi esetekben nyereményjátékok szervezése, lebonyolítása, a nyertesek
                                kiértesítése
                                és részükre a nyeremény biztosítása;
                            </li>
                            <li>xi.az informatikai rendszer technikai fejlesztése;</li>
                            <li>xii.a Felhasználók jogainak védelme;</li>
                            <li>xiii.az Adatkezelő jogos érdekeinek érvényesítése.</li>
                            <li></li>
                            <li>Adatkezelő a fent ismertetett bármelyik adatkezelési cél megvalósítása érdekében
                                kezelhet adatokat.
                            </li>
                            <li>Az Adatkezelők a megadott adatokat az e pontokban írt céloktól eltérő célokra nem
                                használják fel.
                            </li>
                            <li></li>
                        </ol>
                        <ol>
                            <li>Az Adatkezelésre a Felhasználók önkéntes, megfelelő tájékoztatáson alapuló
                                nyilatkozata
                                alapján kerül sor, amely nyilatkozat tartalmazza a Felhasználók kifejezett
                                hozzájárulását ahhoz, hogy az oldal használata során általuk közölt adataik, illetve
                                a
                                róluk generált adatok felhasználásra kerüljenek. A Felhasználó a hozzájáruláson
                                alapuló
                                adatkezelés esetén jogosult a hozzájárulását bármikor visszavonni, amely azonban nem
                                érinti a visszavonás előtti adatkezelés jogszerűségét.
                            </li>
                        </ol>

                        <li>i.Az Adatkezelő a Felhasználó által a Honlapra történő belépéskor a Felhasználó IP címét
                            a
                            Szolgáltatás nyújtásához kapcsolódóan, az Adatkezelők jogos érdekére tekintettel és a
                            Szolgáltatás jogszerű biztosítása okán (pl. jogellenes felhasználás ill. jogellenes
                            tartalmak kiszűrése érdekében), a Felhasználó külön hozzájárulása nélkül is rögzítik.
                        </li>
                        <li>ii.A tartalomszolgáltatás keretében ill. ahhoz kapcsolódóan történő Adatkezelés
                            jogalapja
                            lehet a Felhasználó önkéntes hozzájárulásán kívül az Adatkezelő lényeges jogos érdeke,
                            valamint a tájékoztatáshoz és a véleménynyilvánításhoz való alapvető jogok biztosítása,
                            a
                            jogszabályok által meghatározott keretek között.
                        </li>
                        <li>iii.Abban esetben, amikor az Adatkezelés jogalapja az Adatkezelők lényeges jogos érdeke,
                            az
                            Adatkezelők a GDPR vonatkozó rendelkezéseivel összhangban elvégezték és a jövőben is
                            elvégezhetik az érdekmérlegelési tesztet, amely alátámasztja, hogy az Adatkezelő adott
                            Adatkezeléshez kapcsolódó jogos érdeke erősebb az érintettnek az Adatkezeléssel
                            összefüggő
                            jogainál és szabadságainál. Az Adatkezelők erre irányuló kérés esetén a jelen
                            Tájékoztatóban
                            írtak szerint tájékoztatást nyújtanak az érintett részére a jelen bekezdésben
                            foglaltakkal
                            kapcsolatban.
                        </li>
                        <li>iv.Jelen Tájékoztatóban meghatározott Adatfeldolgozók részére történő Adattovábbítás a
                            Felhasználó külön hozzájárulása nélkül végezhető. Személyes adatok harmadik személynek
                            vagy
                            hatóságok számára történő kiadása – hacsak jogszabály ettől eltérően nem rendelkezik
                            –kizárólag hatósági határozat alapján, vagy a Felhasználó előzetes, kifejezett
                            hozzájárulása
                            esetén lehetséges.
                        </li>
                        <ol>
                            <li>A Felhasználó szavatol azért, hogy a Szolgáltatások igénybevétele során általa más
                                természetes személyekről megadott vagy hozzáférhetővé tett személyes adat
                                kezeléséhez
                                (pl. a Felhasználó által generált tartalom közzététele során stb.) az érintett
                                természetes személy hozzájárulását jogszerűen beszerezte. A Felhasználó által a
                                Szolgáltatásokba feltöltött, megosztott felhasználói tartalomért minden felelősség a
                                Felhasználót terheli.
                            </li>
                            <li>Bármely Felhasználó e-mail címének valamint a regisztráció/kapcsolatfelvétel során
                                megadott adatainak (pl. felhasználó név, azonosító, jelszó stb.) megadásakor egyben
                                felelősséget vállal azért, hogy a megadott e-mail címről ill. az általa megadott
                                adatok
                                felhasználásával kizárólag ő vesz igénybe szolgáltatást. E felelősségvállalásra
                                tekintettel egy megadott e-mail címen és/vagy adatokkal történt belépésekkel
                                összefüggő
                                mindennemű felelősség kizárólag azt a Felhasználót terheli, aki az e-mail címet
                                regisztrálta és az adatokat megadta.
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Az Adatkezelés alapelvei, módja
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő az adatokat a jóhiszeműség és a tisztesség és átláthatóság
                                        elveinek, valamint a hatályos jogszabályok és jelen Tájékoztató
                                        rendelkezéseinek
                                        megfelelően kezeli.
                                    </li>
                                    <li>A Szolgáltatások igénybevételéhez elengedhetetlenül szükséges Személyes
                                        adatokat
                                        az Adatkezelő az érintett Felhasználó hozzájárulása alapján, és kizárólag
                                        célhoz
                                        kötötten használja fel.
                                    </li>
                                    <li>Az Adatkezelő az adatokat csak a jelen Tájékoztatóban ill. a vonatkozó
                                        jogszabályokban meghatározott célból kezelik. A kezelt Személyes adatok köre
                                        arányban áll az Adatkezelés céljával, azon nem terjeszkedhet túl. Minden
                                        olyan
                                        esetben, amikor az adatokat az Adatkezelő az eredeti adatfelvétel céljától
                                        eltérő célra kívánja felhasználni, erről a Felhasználót tájékoztatja, és
                                        ehhez
                                        előzetes, kifejezett hozzájárulását megszerzi, illetőleg lehetőséget
                                        biztosít
                                        számára, hogy a felhasználást megtiltsa.
                                    </li>
                                    <li>Adatkezelő a megadott adatokat nem ellenőrzi. A megadott Személyes adatok
                                        megfelelőségéért kizárólag az azt megadó személy felel.
                                    </li>
                                    <li>Az Adatkezelő az általa kezelt adatokat a jelen Tájékoztatóban meghatározott
                                        Adatfeldolgozón, valamint egyes – a jelen Tájékoztatóban hivatkozott –
                                        esetekben
                                        a Külső szolgáltatókon kívül harmadik félnek nem adja át. A jelen pontban
                                        foglalt rendelkezés alól kivételt képez az adatok statisztikailag
                                        összesített
                                        formában történő felhasználása, mely az érintett Felhasználó beazonosítására
                                        alkalmas egyéb adatot semmilyen formában nem tartalmazhatja, ez által nem
                                        minősül Adatkezelésnek, sem adattovábbításnak. Az Adatkezelő bizonyos
                                        esetekben
                                        – hivatalos bírósági, rendőrségi megkeresés, jogi eljárás szerzői-, vagyoni-
                                        illetve egyéb jogsértés vagy ezek alapos gyanúja miatt az Adatkezelő
                                        érdekeinek
                                        sérelme, a Szolgáltatások biztosításának veszélyeztetése stb. – harmadik
                                        személyek számára hozzáférhetővé teszik az érintett Felhasználó elérhető
                                        adatait.
                                    </li>
                                    <li>Az Adatkezelő rendszere a Felhasználók aktivitásáról adatokat gyűjthet,
                                        melyek
                                        nem kapcsolhatók össze a Felhasználók által a regisztrációkor megadott egyéb
                                        adatokkal, sem más honlapok vagy szolgáltatások igénybevételekor keletkező
                                        adatokkal.
                                    </li>
                                    <li>Az Adatkezelő az általuk kezelt Személyes adat helyesbítéséről,
                                        korlátozásáról,
                                        ill. törléséről az érintett Felhasználót, továbbá mindazokat értesíti,
                                        akiknek
                                        korábban az adatot Adatkezelés céljára továbbította. Az értesítés
                                        mellőzhető, ha
                                        ez az Adatkezelés céljára való tekintettel az érintett jogos érdekét nem
                                        sérti.
                                    </li>
                                    <li>Az Adatkezelő gondoskodik a Személyes adatok biztonságáról, megteszik azokat
                                        a
                                        technikai és szervezési intézkedéseket, és kialakítják azokat az eljárási
                                        szabályokat, amelyek biztosítják, hogy a felvett, tárolt, illetve kezelt
                                        adatok
                                        védettek legyenek, illetőleg megakadályozza azok véletlen elvesztését,
                                        jogtalan
                                        megsemmisülését, jogosulatlan hozzáférését, jogosulatlan felhasználását és
                                        jogosulatlan megváltoztatását, jogosulatlan terjesztését. E kötelezettség
                                        teljesítésére az Adatkezelő minden olyan harmadik felet felhív, akik részére
                                        adatokat továbbít.
                                    </li>
                                    <li>Tekintettel a GDPR vonatkozó rendelkezéseire az Adatkezelő nem köteles
                                        adatvédelmi tisztviselő kijelölésére.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Az Adatkezelés időtartama
                                <br/><br/>
                                <ol>
                                    <li>Az automatikusan rögzített IP címeket az Adatkezelő a rögzítésüket követően
                                        legfeljebb a törlésig tárolja.
                                    </li>
                                    <li>A Felhasználó által küldött e-mailek esetén, ha a Felhasználó amúgy nem
                                        rendelkezik regisztrációval, a megkeresett Adatkezelő az e-mail címet a
                                        megkeresésben hivatkozott ügy lezárását követő 90. napon törli, kivéve, ha
                                        egyedi esetben az Adatkezelő jogos érdeke az adat további kezelését
                                        indokolja,
                                        az Adatkezelő e jogos érdekének fennállásáig.
                                    </li>
                                    <li>A Felhasználó által megadott Személyes adatok kezelése mindaddig fennmarad,
                                        amíg
                                        a Felhasználó a Szolgáltatásról – az adott felhasználói névvel – ki nem
                                        iratkozik, vagy egyébként nem kéri az adatok törlését. Ez esetben a
                                        Személyes
                                        adat az Adatkezelő rendszereiből törlődik.A Felhasználó által megadott
                                        Személyes
                                        adatok – abban az esetben is, ha a Felhasználó a Szolgáltatásról nem
                                        iratkozik
                                        le vagy regisztrációja törlésével csak a belépési lehetőséget szüntette meg,
                                        és
                                        az azokban tárolt hozzászólások és feltöltött tartalmak megmaradnak –addig
                                        kezelhetőek az Adatkezelő által, amíg a Felhasználó kifejezetten írásban nem
                                        kéri azok Adatkezelésének megszüntetését. A Felhasználó Adatkezelés
                                        megszüntetésére irányuló, a Szolgáltatásról való leiratkozás nélküli kérése
                                        a
                                        Szolgáltatás igénybe vételéhez fűződő jogát nem érinti, azonban
                                        előfordulhat,
                                        hogy Személyes adatok hiányában egyes Szolgáltatásokat nem tud majd igénybe
                                        venni.
                                    </li>
                                    <li>jogellenes, megtévesztő Személyes adat használata esetén vagy a Felhasználó
                                        által elkövetett bűncselekmény, illetve rendszer elleni támadás esetén az
                                        Adatkezelő jogosult a Felhasználó regisztrációjának megszűnésével
                                        egyidejűleg
                                        Személyes adatait haladéktalanul törölni, ugyanakkor – bűncselekmény gyanúja
                                        vagy polgári jogi felelősség gyanúja esetén – jogosult a Személyes adatokat
                                        a
                                        lefolytatandó eljárás időtartamára megőrizni.
                                    </li>
                                    <li>A rendszer működése során automatikusan, technikailag rögzítésre kerülő
                                        adatok a
                                        generálódásuktól számítva a rendszer működésének biztosítása szempontjából
                                        indokolt időtartamig kerülnek tárolásra a rendszerben. Az Adatkezelő
                                        biztosítja,
                                        hogy ezen, automatikusan rögzített adatok egyéb Személyes adatokkal – a
                                        jogszabály által kötelezővé tett esetek kivételével – össze nem
                                        kapcsolhatók. Ha
                                        a Felhasználó Személyes adatainak kezeléséhez adott hozzájárulását
                                        megszüntette,
                                        vagy a Szolgáltatásról leiratkozott, úgy ezt követően a technikai adatokról
                                        az ő
                                        személye – nyomozó hatóságokat illetve szakértőiket ide nem értve – nem lesz
                                        beazonosítható.
                                    </li>
                                    <li>Amennyiben bíróság vagy hatóság jogerősen elrendeli a Személyes adat
                                        törlését, a
                                        törlést az Adatkezelők végrehajtják. Törlés helyett az Adatkezelők – a
                                        Felhasználó tájékoztatása mellett –korlátozzák a Személyes adat
                                        felhasználását,
                                        ha a Felhasználó ezt kéri, vagy ha a rendelkezésére álló információk alapján
                                        feltételezhető, hogy a törlés sértené a Felhasználó jogos érdekét. A
                                        Személyes
                                        adatot az Adatkezelők mindaddig nem törlik, ameddig fennáll az az
                                        adatkezelési
                                        cél, amely a Személyes adat törlését kizárta.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>A Felhasználó jogai, érvényesítésük módja
                                <br/><br/>
                                <ol>
                                    <li>A Felhasználó Személyes adatok kezeléséről bármikor írásban, az Adatkezelő
                                        címére küldött ajánlott vagy tértivevényes-ajánlott levélben, illetve az <a
                                            href="mailto:info@inteliart.hu" target="_blank">info@inteliart.hu</a> e-mail
                                        címre küldött e-mailben tájékoztatást kérhet. A levélben küldött
                                        tájékoztatás
                                        kérést az Adatkezelő akkor tekinti hitelesnek, ha a megküldött kérelem
                                        alapján a
                                        Felhasználó egyértelműen beazonosítható. A tájékoztatáskérés kiterjedhet a
                                        Felhasználónak az Adatkezelő által kezelt adataira, azok forrására, az
                                        Adatkezelés céljára, jogalapjára, időtartamára, az esetleges Adatfeldolgozó
                                        nevére és címére, az Adatkezeléssel összefüggő tevékenységekre, valamint a
                                        Személyes adatoknak továbbítása esetén arra, hogy kik és milyen célból
                                        kapták
                                        vagy kapják meg Felhasználó adatait.
                                    </li>
                                    <li>A Felhasználó kérheti az Adatkezelő által kezelt Személyes adatainak
                                        helyesbítését vagy módosítását, figyelembe véve az Adatkezelés célját, a
                                        Felhasználó kérheti a hiányos Személyes adatok kiegészítését. A Felhasználó
                                        által az adott Szolgáltatáshoz kapcsolódóan megadott. Az adat módosítására
                                        irányuló igény teljesítését követően a korábbi (törölt) adatok már nem
                                        állíthatók helyre.
                                    </li>
                                    <li>A Felhasználó kérheti az Adatkezelő által kezelt adatainak törlését. A
                                        törlés
                                        megtagadható (i) a véleménynyilvánítás szabadságához és a tájékozódáshoz
                                        való
                                        jog gyakorlása céljából, vagy (ii) ha a Személyes adatok kezelésére
                                        jogszabály
                                        felhatalmazást ad; valamint (iii) jogi igények előterjesztéséhez,
                                        érvényesítéséhez, illetve védelméhez. A törlési kérelem megtagadásáról az
                                        Adatkezelők minden esetben tájékoztatják a Felhasználót, megjelölve a törlés
                                        megtagadásának indokát. Személyes adat törlésére irányuló igény teljesítését
                                        követően a korábbi (törölt) adatok már nem állíthatók helyre. Az Adatkezelő
                                        által küldött hírlevelek az azokban található leiratkozás linken keresztül
                                        mondhatók le. Leiratkozás esetén az Adatkezelő a hírlevél adatbázisában a
                                        Felhasználó Személyes adatait törli.
                                    </li>
                                    <li>A Felhasználó kérheti, hogy Személyes adatainak kezelését az Adatkezelő
                                        korlátozza, ha a Felhasználó vitatja a kezelt Személyes adatok pontosságát.
                                        Ebben az esetben a korlátozás arra az időtartamra vonatkozik, amely lehetővé
                                        teszi, hogy az Adatkezelő ellenőrizze a Személyes adatok pontosságát. Az
                                        Adatkezelő megjelöli az általa kezelt Személyes adatot, ha a Felhasználó
                                        vitatja
                                        annak helyességét vagy pontosságát, de a vitatott Személyes adat
                                        helytelensége
                                        vagy pontatlansága nem állapítható meg egyértelműen. A Felhasználó kérheti,
                                        hogy
                                        adatainak kezelését az Adatkezelő korlátozza akkor is, ha az Adatkezelés
                                        jogellenes, de a Felhasználó ellenzi a kezelt adatok törlését, és ehelyett
                                        kéri
                                        azok felhasználásának korlátozását. A Felhasználó továbbá akkor is kérheti,
                                        hogy
                                        adatainak kezelését az Adatkezelő korlátozza, ha az Adatkezelés célja
                                        megvalósult, de a Felhasználó igényli azok Adatkezelő általi kezelését jogi
                                        igények előterjesztéséhez, érvényesítéséhez vagy védelméhez.
                                    </li>
                                    <li>A Felhasználó kérheti, hogy az Adatkezelő a Felhasználó által rendelkezésére
                                        bocsátott és a Felhasználó által automatizált módon kezelt Személyes
                                        adatokat
                                        tagolt, széles körben használt, géppel olvasható formátumban részére átadják
                                        és/vagy azokat egy másik adatkezelő részére továbbítsa.
                                    </li>
                                    <li>A Felhasználó tiltakozhat Személyes adatainak kezelése ellen (i) ha a
                                        Személyes
                                        adatok kezelése kizárólag az Adatkezelőre vonatkozó jogi kötelezettség
                                        teljesítéséhez vagy az Adatkezelő vagy harmadik személy jogos érdekének
                                        érvényesítéséhez szükséges; (ii) ha az Adatkezelés célja közvetlen
                                        üzletszerzés,
                                        közvélemény-kutatás vagy tudományos kutatás; vagy (iii) ha az Adatkezelésre
                                        közérdekű feladat teljesítése érdekében kerül sor. Az Adatkezelő a
                                        Felhasználó
                                        tiltakozásának jogszerűségét megvizsgálja, és ha a tiltakozás
                                        megalapozottságát
                                        megállapítja, az Adatkezelést megszünteti és a kezelt Személyes adatokat
                                        zárolja, továbbá a tiltakozásról és az annak alapján tett intézkedésekről
                                        értesítik mindazokat, akik részére a tiltakozással érintett Személyes adatok
                                        korábban továbbításra kerültek.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Adatfeldolgozás
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő tevékenysége ellátásához a jelen Tájékoztatóban fentebb
                                        nevesített
                                        Adatfeldolgozókat veszik igénybe.
                                    </li>
                                    <li>Az Adatfeldolgozók önálló döntést nem hoznak, kizárólag az Adatkezelővel
                                        kötött
                                        szerződés, és a kapott utasítások szerint jogosultak eljárni. Az
                                        Adatfeldolgozók
                                        2018. május 25. napját követően a részükre az Adatkezelő által továbbított
                                        és
                                        általuk kezelt vagy feldolgozott Személyes adatokat a GDPR által előírt
                                        rendelkezésekkel összhangban rögzítik, kezelik, ill. dolgozzák fel, és erről
                                        nyilatkozatot tesznek az Adatkezelő részére.
                                    </li>
                                    <li>Az Adatkezelő ellenőrzi az Adatfeldolgozók munkáját.</li>
                                    <li>Az Adatfeldolgozók további adatfeldolgozó igénybe vételére csak az
                                        Adatkezelő
                                        hozzájárulásával jogosult.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Adattovábbítás lehetősége
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő jogosult és köteles minden olyan rendelkezésére álló és általa
                                        szabályszerűen tárolt Személyes adatot az illetékes hatóságoknak
                                        továbbítani,
                                        amely Személyes adat továbbítására őt jogszabály vagy jogerős hatósági
                                        kötelezés
                                        kötelezi. Ilyen Adattovábbítás, valamint az ebből származó következmények
                                        miatt
                                        az Adatkezelő nem tehető felelőssé.
                                    </li>
                                    <li>Amennyiben az Adatkezelő a Szolgáltatások oldalain található
                                        tartalomszolgáltatás és tárhelyszolgáltatás üzemeltetését vagy hasznosítását
                                        részben vagy egészben harmadik személy számára átadja, úgy az általa kezelt
                                        Személyes adatokat részben vagy egészben ezen harmadik személy számára a
                                        Felhasználó külön hozzájárulásának megkérése nélkül, de a Felhasználók
                                        megfelelő
                                        előzetes tájékoztatása mellett átadhatja az új üzemeltető részére azzal,
                                        hogy
                                        ezen adattovábbítás a Felhasználót nem hozhatja a jelen Tájékoztató
                                        mindenkor
                                        hatályos szövegében megjelölt adatkezelési szabályoknál hátrányosabb
                                        helyzetbe.
                                        Jelen pont szerinti adattovábbítás esetén az Adatkezelő az adattovábbítás
                                        előtt
                                        lehetőséget biztosít a Felhasználók számára arra, hogy az adattovábbítás
                                        előtt
                                        tiltakozzanak az adattovábbítás ellen. Tiltakozás esetén az adott
                                        Felhasználó
                                        adatainak a jelen pont szerinti továbbítása nem lehetséges.
                                    </li>
                                    <li>Az Adatkezelők az adattovábbítás jogszerűségének ellenőrzése, valamint a
                                        Felhasználó tájékoztatásának biztosítása céljából adattovábbítási
                                        nyilvántartást
                                        vezetnek.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Külső szolgáltatók
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő a Szolgáltatások biztosításához kapcsolódóan számos esetben
                                        Külső
                                        szolgáltatókat vesz igénybe, amely Külső szolgáltatókkal az Adatkezelő
                                        együttműködik. A Külső szolgáltatók rendszereiben kezelt Személyes adatok
                                        tekintetében a Külső szolgáltatók saját adatvédelmi tájékoztatójában
                                        foglaltak
                                        az irányadók. Az Adatkezelő mindent megtesz annak érdekében, hogy a Külső
                                        szolgáltató a részére továbbított Személyes adatokat a jogszabályoknak
                                        megfelelőn kezelje, és azokat kizárólag a Felhasználó által meghatározott
                                        vagy a
                                        jelen Tájékoztatóban alább rögzített célra használja fel. A Külső
                                        szolgáltatók
                                        2018. május 25. napját követően a részükre az Adatkezelő által továbbított
                                        és
                                        általuk kezelt vagy feldolgozott Személyes adatokat a GDPR által előírt
                                        rendelkezésekkel összhangban rögzítik, kezelik, ill. dolgozzák fel és erről
                                        nyilatkozatot tesznek az Adatkezelő részére. Az Adatkezelő a Külső
                                        szolgáltatók
                                        számára végzett adattovábbításról a jelen Tájékoztató keretében tájékoztatja
                                        a
                                        Felhasználókat.
                                    </li>
                                    <li>Regisztrációt vagy belépést könnyítő Külső szolgáltatók Az Adatkezelők a
                                        Szolgáltatások biztosításához kapcsolódóan együttműködnek olyan Külső
                                        szolgáltatókkal, amelyek regisztrációt és belépést könnyítő alkalmazásokat
                                        biztosítanak a Felhasználók számára. Ezen együttműködés keretében egyes
                                        Személyes adatok (pl. IP cím, e-mail, regisztrációs név) e Külső
                                        szolgáltatók
                                        által az Adatkezelő és/vagy az Adatfeldolgozó részére átadásra kerülhetnek.
                                        E
                                        Külső szolgáltatók a Személyes adatokat saját adatvédelmi irányelveik
                                        szerint
                                        gyűjtik, kezelik, továbbítják. Az Adatkezelőkkel együttműködő Regisztrációt
                                        vagy
                                        belépést könnyítő Külső szolgáltatók:
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p>i.Facebook Inc.</p>
                        <ol>
                            <li>Webanalitikai és hirdetéskiszolgáló Külső szolgáltatók A Szolgáltatások oldalhoz
                                kapcsolódóan az Adatkezelők webanalitikai és hirdetéskiszolgáló Külső
                                szolgáltatókkal
                                működnek együtt. E Külső szolgáltatók hozzáférhetnek a Felhasználó IP címéhez, ezen
                                felül pedig sok esetben cookie-k, esetenként web beacon (az IP cím, a látogatott
                                honlap
                                rögzítésére szolgáló, a honlapokon, esetenként e-mailekben vagy mobil applikációkban
                                alkalmazott webes jelölő), clicktag (egy adott hirdetésre történt kattintást
                                azonosító
                                jelölő mérőkód) vagy egyéb kattintásmérők használatával biztosítják a Szolgáltatások
                                személyre szabását vagy elemzését, statisztikák készítését. Az e Külső szolgáltatók
                                által elhelyezett cookie-k bármikor törölhetők a Felhasználó készülékéről, a
                                böngésző(k)
                                megfelelő beállításainak kiválasztásával pedig általában visszautasítható a cookie-k
                                használata. A Külső szolgáltatók által elhelyezett cookie beazonosítása az adott
                                cookie-hoz kapcsolódó domain alapján történhet. A web beacon, a clicktag és az egyéb
                                kattintásmérők visszautasítására nincs lehetőség. E Külső szolgáltatók a részükre
                                továbbított Személyes adatokat saját adatvédelmi tájékoztatóik szerint kezelik. Az
                                Adatkezelőkkel együttműködő webanalitikai és hirdetéskiszolgáló Külső szolgáltatók:
                                Google Analytics.
                            </li>
                            <li>Felület (tárhely) biztosítása esetén</li>
                        </ol>
                        <p>i.A Szolgáltatások biztosítása szempontjából az Adatkezelő Külső szolgáltatónak tekinti
                            azon
                            Felhasználókat, akik az Adatkezelő által biztosított felületeket saját tartalom
                            közzététele
                            céljából, tárhelyként veszik igénybe. A Felhasználó az általa használt felületre saját
                            döntése alapján feltölthet Személyes adatokat, vagy használhat olyan szolgáltatásokat,
                            amelyek segítségével Személyes adatokat gyűjthet, rögzíthet, kezelhet a tárhely
                            felületen.
                            Mindazon esetekben, amikor az Adatkezelő mint szolgáltató a Felhasználó részére
                            felületet
                            biztosít, az ezen felületen kezelt Személyes adatokkal kapcsolatosan adatkezelési
                            tevékenységet nem végez. Az itt kezelt adatok jogszabályoknak megfelelő kezeléséért a
                            tárhelyszolgáltatás igénybe vevőit terheli minden felelősség.</p>
                        <ol>
                            <li>Egyéb Külső szolgáltatók</li>
                        </ol>
                        <p>i.Vannak olyan Külső szolgáltatók, amelyekkel Adatkezelő nem áll szerződéses
                            jogviszonyban
                            vagy az adott adatkezelés tekintetében szándékosan nem működik együtt, azonban ettől
                            függetlenül is a Honlaphoz / Szolgáltatásokhoz – akár a Felhasználó közreműködése (pl.
                            egyéni fiókjának a Szolgáltatáshoz kapcsolása) által, akár anélkül –hozzáférnek, és ez
                            által
                            a Felhasználókról vagy a Szolgáltatások honlapjain folytatott felhasználói
                            aktivitásokról
                            adatokat gyűjtenek, amelyekből esetenként – önállóan vagy más, Külső szolgáltató által
                            gyűjtött adatokkal összekapcsolva – alkalmasak lehetnek a Felhasználó azonosítására.
                            Ilyen
                            Külső szolgáltatók lehetnek különösen, de nem kizárólagosan: Facebook, Ireland LTD.,
                            Google
                            LLC, Instagram LLC., Infogram Software Inc, PayPal Holdings Inc., Pinterest Europe Ltd.,
                            Playbuzz Ltd., Twitter International Company, Vimeo INC., YouTube LLC</p>
                        <p></p>
                        <ol>
                            <li>Az Adatkezelési Tájékoztató módosítása
                                <br/><br/>
                                <ol>
                                    <li>Az Adatkezelő fenntartja magának a jogot, hogy a jelen Tájékoztatót –a
                                        vonatkozó
                                        jogszabályok megtartása mellett- egyoldalú döntésével bármikor módosítsa.
                                    </li>
                                    <li>A Felhasználó következő belépéssel elfogadja a Tájékoztató mindenkor
                                        hatályos
                                        rendelkezéseit, ezen túlmenően az egyes Felhasználók beleegyezésének
                                        kikérésére
                                        nincs szükség.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Eljárás adatvédelmi incidens esetén
                                <br/><br/>
                                <ol>
                                    <li>Az adatvédelmi incidenst az Adatkezelő indokolatlan késedelem nélkül, és ha
                                        lehetséges, legkésőbb 72 órával azután, hogy az adatvédelmi incidens a
                                        tudomására jutott, bejelenti a NAIH-nak, kivéve, ha az adatvédelmi incidens
                                        valószínűsíthetően nem jár kockázattal a természetes személyek jogaira és
                                        szabadságaira nézve. Ha a bejelentés nem történik meg 72 órán belül,
                                        mellékelni
                                        kell hozzá a késedelem igazolására szolgáló indokokat is.
                                    </li>
                                    <li>Az Adatfeldolgozó az adatvédelmi incidenst, az arról való tudomásszerzését
                                        követően indokolatlan késedelem nélkül bejelenti az Adatkezelőnek.
                                    </li>
                                    <li>Az 13.a említett bejelentésben legalább:
                                        <ol>
                                            <li>ismertetni kell az adatvédelmi incidens jellegét, beleértve – ha
                                                lehetséges – az érintettek kategóriáit és hozzávetőleges számát,
                                                valamint az incidenssel érintett adatok kategóriáit és
                                                hozzávetőleges
                                                számát;
                                            </li>
                                            <li>közölni kell a további tájékoztatást nyújtó egyéb kapcsolattartó
                                                nevét
                                                és elérhetőségeit;
                                            </li>
                                            <li>ismertetni kell az adatvédelmi incidensből eredő, valószínűsíthető
                                                következményeket;
                                            </li>
                                            <li>ismertetni kell az Adatkezelő által az adatvédelmi incidens
                                                orvoslására
                                                tett vagy tervezett intézkedéseket, beleértve adott esetben az
                                                adatvédelmi incidensből eredő esetleges hátrányos következmények
                                                enyhítését célzó intézkedéseket.
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                            <li>Ha és amennyiben nem lehetséges az információkat egyidejűleg közölni, azok további
                                indokolatlan késedelem nélkül később részletekben is közölhetők.
                            </li>
                            <li>Az Adatkezelő nyilvántartja az adatvédelmi incidenseket, feltüntetve az adatvédelmi
                                incidenshez kapcsolódó tényeket, annak hatásait és az orvoslására tett
                                intézkedéseket. E
                                nyilvántartás lehetővé teszi, hogy a felügyeleti hatóság ellenőrizze az e cikk
                                követelményeinek való megfelelést.
                            </li>
                            <li>Az Érintett tájékoztatása az adatvédelmi incidensről:</li>
                        </ol>
                        <p>i.Ha az adatvédelmi incidens valószínűsíthetően magas kockázattal jár a természetes
                            személyek
                            jogaira és szabadságaira nézve, az Adatkezelő indokolatlan késedelem nélkül tájékoztatja
                            az
                            érintettet az adatvédelmi incidensről.</p>
                        <p>ii.A 13.f.i. bekezdésben említett, az érintett részére adott tájékoztatásban világosan és
                            közérthetően ismertetni kell az adatvédelmi incidens jellegét, és közölni kell legalább
                            a13.c. pont bekezdésének b), c) és d) pontjában említett információkat és
                            intézkedéseket.</p>
                        <p>iii.Az érintettet nem kell a 13.f.i. bekezdésben említettek szerint tájékoztatni, ha a
                            következő feltételek bármelyike teljesül:</p>
                        <ol>
                            <li>az Adatkezelő megfelelő technikai és szervezési védelmi intézkedéseket hajtott
                                végre, és
                                ezeket az intézkedéseket az adatvédelmi incidens által érintett adatok tekintetében
                                alkalmazták, különösen azokat az intézkedéseket – mint például a titkosítás
                                alkalmazása
                                –, amelyek a személyes adatokhoz való hozzáférésre fel nem jogosított személyek
                                számára
                                értelmezhetetlenné teszik az adatokat;
                            </li>
                            <li>az Adatkezelő az adatvédelmi incidenst követően olyan további intézkedéseket tett,
                                amelyek biztosítják, hogy az érintett jogaira és szabadságaira jelentett, a 13.f.1.
                                pontban említett magas kockázat a továbbiakban valószínűsíthetően nem valósul meg;
                            </li>
                            <li>a tájékoztatás aránytalan erőfeszítést tenne szükségessé. Ilyen esetekben az
                                érintetteket nyilvánosan közzétett információk útján kell tájékoztatni, vagy olyan
                                hasonló intézkedést kell hozni, amely biztosítja az érintettek hasonlóan hatékony
                                tájékoztatását.
                            </li>
                            <li>Ha az Adatkezelő még nem értesítette az érintettet az adatvédelmi incidensről, a
                                NAIH,
                                miután mérlegelte, hogy az adatvédelmi incidens valószínűsíthetően magas kockázattal
                                jár-e, elrendelheti az Érintett tájékoztatását, vagy megállapíthatja a 13.c.
                                bekezdésben
                                említett feltételek valamelyikének teljesülését.
                            </li>
                        </ol>
                        <p></p>
                        <ol>
                            <li>Jogérvényesítési lehetőségek
                                <br/><br/>
                                <ol>
                                    <li>Bármilyen, adatkezeléssel kapcsolatos kérdéssel, észrevétellel kereshetők az
                                        Adatkezelő munkatársai a<a href="mailto:info@inteliart.hu"
                                                                   target="_blank">info@inteliart.hu</a>e-mail
                                        címen.
                                    </li>
                                    <li>A Felhasználó az Adatkezeléssel kapcsolatos panaszával közvetlenül a Nemzeti
                                        Adatvédelmi és Információszabadság Hatósághoz (cím: <a
                                            href="https://maps.google.com/?q=1125+Budapest,+Szil%C3%A1gyi+Erzs%C3%A9bet+fasor+22&amp;entry=gmail&amp;source=g"> 1125
                                            Budapest, Szilágyi Erzsébet fasor 22</a>/c.; telefon: +36-1-391-1400;
                                        e-mail: <a href="mailto:ugyfelszolgalat@naih.hu"
                                                  target="_blank">ugyfelszolgalat@naih.hu</a>; honlap: <a
                                            href="http://www.naih.hu/" target="_blank">www.naih.hu</a>) fordulhat.
                                    </li>
                                    <li>A Felhasználó jogainak megsértése esetén bírósághoz fordulhat. A per
                                        elbírálása
                                        törvényszék hatáskörébe tartozik.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                        <p></p>
                        <p>2020 október 5.</p>
                        <p></p>
                        <p>Hajzer Bence</p>
                        <p></p>

                    </div>
                </div>
            </ModalComponent>

            <Container className="contactComponent">

                <div className="container relative">
                    <div className="col-12">
                        <div className="relative">
                            <h1 className="MS text-white text-center fw-bold fst-italic">{Translation.get('contact.title')}</h1>
                            <div className="col-12 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2">
                                <p className="MS text-white text-center fst-italic">{Translation.get('contact.description')}</p>
                            </div>

                            <div className="our-contacts col-12 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2">
                                <p>Inteliart Online Marketing</p>
                                <p><a className="text-white"
                                      href='&#109;ai&#108;to&#58;i%6&#69;&#102;o&#64;&#37;69n&#37;74%65&#108;iar%74&#46;h&#117;'>inf&#111;&#64;i&#110;t&#101;&#108;ia&#114;&#116;&#46;hu</a>
                                </p>
                                <p>+36 20 77 25 707</p>
                                <p>2440 Százhalombatta, Csalogány utca 19</p>
                                <div className="icon-container d-flex justify-content-center align-items-center">
                                    <a href="https://www.facebook.com/InteliArt/" target="_blank">
                                        <img src={facebookIcon} alt=""/>
                                    </a>
                                    <a href="https://www.linkedin.com/company/inteliart-media/" target="_blank">
                                        <img src={linkedinIcon} alt=""/>
                                    </a>
                                </div>
                            </div>

                            <img src={planeSvg}
                                 className={`plain ${this.state.success ? 'SUCCESS' : ''} ${this.state.error ? 'ERROR' : ''} UNINIT`}/>
                        </div>

                        <div
                            className={`col-12 col-md-10 offset-md-1 formWrapper ${this.state.success ? 'SUCCESS' : ''} ${this.state.error ? 'ERROR' : ''}`}>

                            <div className="formOuter">
                                <h3 className="MS d-none d-lg-block text-white">{Translation.get('contact.form.title')}</h3>

                                <br/>
                                <br/>

                                <form className="row" onSubmit={(event: any) => this.onFormSubmit(event)}>

                                    <div
                                        className={`formGroup col-12 col-sm-6 d-inline-block text-white MS ${this.form.validator('name') ? 'invalid' : 'valid'} ${this.form.value('name') ? 'hasValue' : ''}`}>
                                        <input className="DISABLE_HAMMER_EVENT" type="text" name="name" id="name"
                                               value={this.form.value('name')}
                                               onChange={(event: any) => this.form.value('name', event.target.value)}/>
                                        <label htmlFor="name">{Translation.get('contact.form.name.title')}</label>

                                        <span className="validatorMessage">{this.form.validatorMessage('name')}</span>
                                    </div>

                                    <div
                                        className={`formGroup col-12 col-sm-6 d-inline-block text-white MS ${this.form.validator('email') ? 'invalid' : 'valid'} ${this.form.value('email') ? 'hasValue' : ''}`}>
                                        <input className="DISABLE_HAMMER_EVENT" type="text" name="email" id="email"
                                               value={this.form.value('email')}
                                               onChange={(event: any) => this.form.value('email', event.target.value)}/>
                                        <label htmlFor="email">{Translation.get('contact.form.email.title')}</label>

                                        <span className="validatorMessage">{this.form.validatorMessage('email')}</span>
                                    </div>

                                    <div
                                        className={`formGroup col-12 col-sm-12 d-inline-block text-white MS ${this.form.validator('phone') ? 'invalid' : 'valid'} ${this.form.value('phone') ? 'hasValue' : ''}`}>
                                        <input className="DISABLE_HAMMER_EVENT" type="text" name="phone" id="phone"
                                               value={this.form.value('phone')}
                                               onChange={(event: any) => this.form.value('phone', event.target.value)}/>
                                        <label htmlFor="phone">{Translation.get('contact.form.phone.title')}</label>

                                        <span className="validatorMessage">{this.form.validatorMessage('phone')}</span>
                                    </div>

                                    <div
                                        className="formGroup col-12 col-sm-12 d-inline-block text-white MS">
                                <textarea className="DISABLE_HAMMER_EVENT" name="message" id="message"
                                          value={this.form.value('message')}
                                          ref={(ref: any) => this.textAreaRef = ref}
                                          onChange={(event: any) => this.form.value('message', event.target.value)}
                                          style={{lineHeight: `${lineHeight}px`}}
                                          rows={this.state.rows}/>
                                        <label htmlFor="message">{Translation.get('contact.form.message.title')}</label>
                                    </div>

                                    <div
                                        className={`col-12 col-sm-12 MS text-white formCheckbox mt-3 form-check ${this.form.validator('gdpr') ? 'invalid' : 'valid'}`}>

                                        <input type="checkbox" name="gdpr" id="gdpr" className="form-check-input"
                                               checked={this.form.value('gdpr')}
                                               onChange={() => this.form.value('gdpr', !this.form.value('gdpr'))}/>
                                        <label className="form-check-label"
                                               htmlFor="gdpr">{Translation.get('contact.form.privacy.title')}&nbsp;
                                        </label>
                                        <a className='gdpr-link' onClick={() => this.tcModalRef.openModal()}>
                                            {Translation.get('contact.form.privacy.link')}.
                                        </a>
                                    </div>

                                    {/*
                                <div
                                    className={`col-12 col-sm-12 MS text-white formCheckbox mt-3 form-check ${this.form.validator('eula') ? 'invalid' : 'valid'}`}>

                                    <input type="checkbox" name="eula" id="eula" className="form-check-input"
                                           checked={this.form.value('eula')}
                                           onChange={() => this.form.value('eula', !this.form.value('eula'))}/>

                                    <label className="form-check-label" htmlFor="eula">Hozzájárulok ahhoz, hogy az
                                        InteliArt
                                        Online Marketing Kft. az általam
                                        megadott elérhetőségeimre hírlevelet és akciós ajánlatokat, tájékoztatókat
                                        küldjön.&nbsp;

                                        <a onClick={(event: any) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            this.setState({eulaModal: true});
                                        }}>Részletek</a>
                                    </label>
                                </div>
                                */}

                                    <div className="col-12 col-sm-12 pt-3">
                                        <button className="send">{Translation.get('contact.form.button.title')}</button>
                                    </div>

                                </form>
                            </div>

                            <div className="formOuterMessage align-items-center align-items-sm-start">
                                {this.state.success && <div>
                                    <h3>{Translation.get('contact.form.sendSucc.title')}</h3>
                                    <span
                                        className="d-none d-sm-block">{Translation.get('contact.form.sendSucc.description')}</span>
                                </div>}

                                {this.state.error && <div>
                                    <h3>{Translation.get('contact.form.sendErr.title')}</h3>
                                    <a className="d-none d-sm-block pointer"
                                       onClick={() => window.location.reload()}>{Translation.get('contact.form.sendErr.description')}</a>
                                </div>}
                            </div>

                        </div>
                    </div>
                </div>

                {/*<ReactModal
                onRequestClose={() => this.setState({gpdrModal: false})}
                shouldCloseOnOverlayClick={true}
                shouldFocusAfterRender={true}
                shouldCloseOnEsc={true}
                parentSelector={() => document.body}
                ariaHideApp={true}
                isOpen={this.state.gpdrModal}>
                <div className="ReactModal__Close" onClick={() => this.setState({gpdrModal: false})}>
                    <img src={closeIcon}/>
                </div>
                {Adatvedelmi()}
            </ReactModal>*/}
            </Container></div>;
    }
}
